import { toLatinDigits } from "@/lib/arabic-format";

const asList = (v: unknown): string[] =>
  Array.isArray(v) ? v.filter((x): x is string => typeof x === "string") : typeof v === "string" && v ? [v] : [];

/** Lowest start to highest end across the post's age bands, e.g. «1–6». Null when none parse. */
export function ageRange(ageBand: unknown): string | null {
  const nums = asList(ageBand).flatMap((b) =>
    (toLatinDigits(b).match(/\d+(?:\.\d+)?/g) ?? []).map(Number),
  );
  if (!nums.length) return null;
  const lo = Math.min(...nums);
  const hi = Math.max(...nums);
  return lo === hi ? String(lo) : `${lo}–${hi}`;
}

export function firstRakiza(rakiza: unknown): string | null {
  return asList(rakiza)[0] ?? null;
}

export type Tone = "green" | "blue" | "coral" | "neutral";

export function rakizaTone(rakiza: string | null): Tone {
  if (!rakiza) return "neutral";
  if (rakiza.includes("الأمان النفسي")) return "green";
  if (rakiza.includes("تنظيم المشاعر") || rakiza.includes("التواصل")) return "blue";
  if (rakiza.includes("الكفاءة الاجتماعية")) return "coral";
  return "neutral";
}

export const TONE_CLASS: Record<Tone, string> = {
  green: "bg-green-100 text-green-800",
  blue: "bg-blue-100 text-blue-700",
  coral: "bg-coral-100 text-coral-700",
  neutral: "bg-cream-100 text-text-secondary",
};

export function fillDuration(text: string, duration: number | string): string {
  return text.replaceAll("{duration}", String(duration));
}
